import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useEmployeeTaxFormsEngagementContext = (): string => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    // An unset context must stay empty so checklist/schema queries stay
    // disabled instead of firing with a junk engagement id.
    return params.get("engagementId") ?? "";
  }, [location.search]);
};
